/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {useCallback, useState} from 'react';

/**
 * The useShowDeletePrompt hook provides the hide/show status of Delete prompt.
 *
 * ```typescript
 *
 * import {useShowDeletePrompt} from '@ion/dls/src/hooks/useShowDeletePrompt';
 *
 *  ...
 *
 *  const {setShowError, setShowSuccess, showSuccess, showError, closeSnack} = useShowDeletePrompt();
 *
 * ```
 */
export const useShowDeletePrompt = () => {
  const [showError, setShowError]     = useState<boolean>(false);
  const [showSuccess, setShowSuccess] = useState<boolean>(false);

  const closeSnack = useCallback(function(): void {
    setShowError(false);
    setShowSuccess(false);
  }, []);

  return {setShowError, setShowSuccess, showSuccess, showError, closeSnack};
};

export default useShowDeletePrompt;
